import { useParams } from "react-router-dom";
import { HAAR_RADIUS_GEMEINDEN } from "@/data/locationsData";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";

const RegionalNutrition = () => {
  const { locationSlug } = useParams<{ locationSlug: string }>();
  const loc = HAAR_RADIUS_GEMEINDEN.find(g => g.slug === locationSlug) || HAAR_RADIUS_GEMEINDEN[0];

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title={`Sporternährungscoaching ${loc.name} | Ernährungsplan | Valorform`}
        description={`Personalisiertes Sporternährungscoaching für Athleten in ${loc.name}.`}
        path={`/nutrition-coaching/${loc.slug}`}
      />
      <Navigation />
      <main className="container mx-auto max-w-4xl px-4 py-24 mt-10">
        <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6">
          Sporternährungscoaching für {loc.name}
        </h1>
        <p className="text-xl text-muted-foreground mb-12 leading-relaxed">
          Egal ob du im Bereich deiner Gemeinde trainierst oder Höchstleistungen anstrebst: Dein biologischer Erfolg entscheidet sich am Küchentisch. Wir konzipieren datenbasierte Ernährungsstrategien für Sportler aus {loc.name}.
        </p>
        <div className="text-center bg-card p-8 rounded-xl border border-border">
          <h3 className="text-2xl font-bold mb-4">Optimiere deine Stoffwechselprozesse datenbasiert</h3>
          <a href="/" className="inline-block bg-primary text-white font-bold px-8 py-3 rounded-lg shadow-md hover:bg-primary/90 transition-colors duration-200">Ernährungs-Checkup vereinbaren</a>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RegionalNutrition;
